import * as React from "react";
import { cn } from "../../../../../utils/cn";

import "./select-filter.css";

type SelectFilterProps = Omit<
  React.SelectHTMLAttributes<HTMLSelectElement>,
  "onChange" | "value"
> & {
  value: string;
  onChange: React.Dispatch<React.SetStateAction<string>>;
  className?: string;
  options: { optionLabel: string; optionValue: string; disabled?: boolean }[];
};

export const SelectFilter = ({
  value,
  onChange,
  className = "",
  options,
  ...selectProps
}: SelectFilterProps) => {
  return (
    <select
      className={cn("border-1 select-filter", className)}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      {...selectProps}
    >
      {options.map((option) => (
        <option
          key={option.optionValue}
          value={option.optionValue}
          disabled={option?.disabled}
        >
          {option.optionLabel}
        </option>
      ))}
    </select>
  );
};
